import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import EditButton from '../../components/shared/EditButton';
import { request, handleRequestErrors } from '../../helpers/Requests'

class DevicesAndProfiles extends Component {
  render() {
    const { location, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {

      return (
        <div className="settings big-settings main-page">
          <div>
            <p className="inline-text">This location has {location.devices} devices</p>
            <EditButton text={'Setup'} link={'/configuration/devices'} extraClass={'no-float'} />
          </div>

          <div>
            <p className="inline-text">This location has {location.profiles} profiles</p>
            <EditButton text={'Setup'} link={'/configuration/profiles'} extraClass={'no-float'} />
          </div>
        </div>
      );
    }
  }

  state = {
    location: [],
    loaded: false,
    error: null,
    unauthorized: null
  };

  componentDidMount() {
    var id = this.props.id;

    request("GET", `/v1/a/locations/${id}/devices_and_profiles`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ location: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default DevicesAndProfiles;
